var map = {
	"./flags/be.svg": 47,
	"./flags/cn.svg": 48,
	"./flags/de.svg": 49,
	"./flags/es.svg": 50,
	"./flags/fr.svg": 51,
	"./flags/gb.svg": 52,
	"./flags/it.svg": 53,
	"./flags/jp.svg": 54,
	"./flags/us.svg": 55,
	"./icons/close.svg": 56,
	"./icons/error.svg": 57,
	"./icons/facebook.svg": 58,
	"./icons/information.svg": 59,
	"./icons/instagram.svg": 60,
	"./icons/linkedin.svg": 61,
	"./icons/marker.svg": 62,
	"./icons/pinterest.svg": 63,
	"./icons/slider-arrow.svg": 64,
	"./icons/success.svg": 65,
	"./icons/twitter.svg": 66,
	"./icons/weibo.svg": 67,
	"./icons/youtube.svg": 68,
	"./logo.png": 69
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;